export default __webpack_public_path__ + "locales/sr-Latn-RS/ChangeUserStatusDialog.json?hash=0ace0da1339a0aff7a4a3b046d5a5cf7";